export default function OrderSuccessModal({ open, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <div className="trade-modal trade-modal--center">
      <button type="button" className="trade-modal__backdrop" aria-label="關閉" onClick={onClose} />
      <div className="trade-modal__panel trade-modal__panel--compact">
        <header className="trade-modal__header">
          <h2>提示</h2>
          <button type="button" className="trade-modal__close" aria-label="關閉" onClick={onClose}>
            ×
          </button>
        </header>
        <div className="trade-success">
          <div className="trade-success__icon" aria-hidden>✓</div>
          <p>下單成功</p>
          <button type="button" className="trade-modal__confirm is-ready" onClick={onClose}>
            知道了
          </button>
        </div>
      </div>
    </div>
  );
}
